import type React from 'react';

import { TextField } from '@change/ds-forms';

import { useNameInput } from './hooks/useNameInput';

export const NameInput: React.FC = () => {
	const {
		data: { label, userName, nameErrorMessage, placeholder },
		actions: { setUserName, focusNameInput },
	} = useNameInput();

	return (
		<TextField
			label={label}
			name="name"
			placeholder={placeholder}
			onChange={(value) => setUserName(value)}
			onFocus={focusNameInput}
			errorMessage={nameErrorMessage}
			isInvalid={!!nameErrorMessage}
			value={userName}
			data-qa="input-cardholder-name"
			id="cardholder-name-input"
		/>
	);
};
